import React from "react";
import { Flame, ChevronDown, Sparkles } from "lucide-react";
import { EmbersBackdrop, GoldDivider } from "./Atoms";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative min-h-[100svh] ember-bg flex items-center pt-28 pb-24 px-6 overflow-hidden"
      data-testid="hero-section"
    >
      <EmbersBackdrop density={18} />

      {/* Subtle background image overlay */}
      <div
        className="absolute inset-0 opacity-[0.22] mix-blend-screen pointer-events-none"
        style={{
          backgroundImage:
            'url("https://static.prod-images.emergentagent.com/jobs/8bd0f279-f617-4678-85ec-2dc9c49f43d0/images/cbe1c75a55ed65b5b70a5553f2e0bd87f3669b5a675865a0f35a87f04c7e36b4.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505] pointer-events-none" />

      <div className="relative max-w-6xl mx-auto w-full text-center">
        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-[#C9A44C]/40 bg-[#0a0a0a]/70 backdrop-blur-md text-[11px] tracking-[0.28em] uppercase text-[#C9A44C] mb-8 shadow-[inset_0_1px_0_rgba(255,255,255,0.04),0_0_24px_-8px_rgba(242,140,24,0.35)]">
          <Flame className="h-3.5 w-3.5 text-[#F28C18]" strokeWidth={1.6} />
          Revival Fire Ministries Global
        </div>

        <h1
          className="font-serif-display text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-[#F6F0E6]"
          data-testid="hero-heading"
        >
          Revival <span className="gold-text italic font-light">Fire</span> Ministries Global
        </h1>
        <div className="mt-3 text-[11px] tracking-[0.3em] uppercase text-[#C9A44C]/80">RFMG Connect</div>

        <div className="mt-8 mx-auto max-w-md">
          <GoldDivider />
        </div>

        <p className="mt-8 text-lg sm:text-xl text-[#F6F0E6]/90 max-w-2xl mx-auto leading-relaxed">
          The official digital hub of <span className="text-[#C9A44C]">Revival Fire Ministries Global</span>.
        </p>

        <p className="mt-5 text-base sm:text-[17px] text-[#D9D9D9] max-w-3xl mx-auto leading-relaxed">
          A prophetic and apostolic holiness revival movement commissioned to draw the
          hearts of men back to God by preaching the unadulterated Word of God with
          power and demonstration of the Spirit of God.
        </p>

        <p className="mt-8 font-serif-display italic text-[#C9A44C] text-xl sm:text-2xl max-w-2xl mx-auto">
          “Come and meet Jesus. Carry the fire. Be trained. Be equipped. Be sent.”
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#prayer" className="btn-fire w-full sm:w-auto" data-testid="hero-cta-prayer">
            <Flame className="h-4 w-4" strokeWidth={1.7} />
            Request Prayer
          </a>
          <a href="#updates" className="btn-ghost w-full sm:w-auto" data-testid="hero-cta-updates">
            Join RFMG Updates
          </a>
          <a href="#give" className="btn-ghost w-full sm:w-auto" data-testid="hero-cta-partner">
            <Sparkles className="h-4 w-4 text-[#C9A44C]" strokeWidth={1.7} />
            Partner With the Fire
          </a>
        </div>

        <a
          href="#hub"
          className="mt-16 inline-flex flex-col items-center gap-2 text-[11px] tracking-[0.32em] uppercase text-[#C9A44C]/80 hover:text-[#C9A44C] transition-colors"
          data-testid="hero-scroll-cue"
        >
          Enter the Hub
          <ChevronDown className="h-4 w-4 animate-bounce" strokeWidth={1.5} />
        </a>
      </div>
    </section>
  );
};

export default Hero;
